import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  command: '',
  commandsList: [],
  isLoadingList: false,
  listError: null,
  output: null,
  isExecuting: false,
  executeError: null,
  executeSuccess: false,
}

const setCommandHandler = (state, { payload }) => {
  state.command = String(payload ?? '')
}

const fetchListRequestHandler = state => {
  state.isLoadingList = true
  state.listError = null
}

const fetchListSuccessHandler = (state, { payload }) => {
  state.isLoadingList = false
  state.commandsList = payload || []
  state.listError = null
}

const fetchListFailureHandler = (state, { payload }) => {
  state.isLoadingList = false
  state.listError = payload || 'Error'
}

const executeRequestHandler = state => {
  state.isExecuting = true
  state.output = null
  state.executeError = null
  state.executeSuccess = false
}

const executeSuccessHandler = (state, { payload }) => {
  state.isExecuting = false
  state.output = payload?.output || ''
  state.executeError = null
  state.executeSuccess = true
}

const executeFailureHandler = (state, { payload }) => {
  state.isExecuting = false
  state.output = payload?.output || null
  state.executeError = payload?.error || 'Error'
  state.executeSuccess = false
}

const resetHandler = state => {
  Object.assign(state, initialState)
}

const slice = createSlice({
  name: 'commandsTools',
  initialState,
  reducers: {
    setCommand: setCommandHandler,
    fetchListRequest: fetchListRequestHandler,
    fetchListSuccess: fetchListSuccessHandler,
    fetchListFailure: fetchListFailureHandler,
    executeRequest: executeRequestHandler,
    executeSuccess: executeSuccessHandler,
    executeFailure: executeFailureHandler,
    reset: resetHandler,
  },
})

export const {
  setCommand,
  fetchListRequest,
  fetchListSuccess,
  fetchListFailure,
  executeRequest,
  executeSuccess,
  executeFailure,
  reset,
} = slice.actions

export default slice.reducer
